module.exports = __webpack_public_path__ + "img/BAWS_Sword3_1_3.c24c5587.png";